import React, { useEffect, useRef } from "react";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

const SliderShow = (props) => {
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && !swiperInstanceRef.current) {
      swiperInstanceRef.current = new Swiper(swiperRef.current, {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          900: {
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            },
          },
        },
      });
    }

    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, []);

  const handleImageClick = () => {
    window.open(
      "https://services.jo.zain.com/ZainBusiness/zainbusinessar.aspx",
      "_blank"
    );
  };

  const images = [
    props.src_image1,
    props.src_image2,
    props.src_image3,
    props.src_image4,
  ];

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        margin: "0 auto",
        padding: "0 60px",
        overflow: "visible",
      }}
    >
      <div className="swiper-container" ref={swiperRef} style={{ height: "450px" }}>
        <div className="swiper-wrapper">
          {images.map((img, index) => (
            <div key={index} className="swiper-slide">
              <img
                src={img}
                alt={`Slide ${index + 1}`}
                onClick={handleImageClick}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  cursor: "pointer",
                  borderRadius: "10px",
                }}
              />
            </div>
          ))}
        </div>
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </div>
    </div>
  );
};

export default SliderShow;
